import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "form",
  id: "password-form"
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { computed, ref } from "vue";
import { httpPost, httpPut } from "@/utils/http";
import { ElMessage } from "element-plus";
export default {
  __name: 'PasswordDialog',
  props: {
    show: Boolean
  },
  emits: ['hide', 'logout'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const showDialog = computed(() => {
      return props.show;
    });
    const form = ref({});
    const emits = __emit;
    const save = function () {
      if (!form.value['newPassword'] || form.value['newPassword'].length < 8) {
        return ElMessage.error({
          message: "密码的长度为8-16个字符",
          appendTo: "#password-form"
        });
      }
      if (form.value['repass'] !== form.value['newPassword']) {
        return ElMessage.error({
          message: '两次输入密码不一致',
          appendTo: '#password-form'
        });
      }
      // httpPost('/api/user/password', form.value).then(() => {
      httpPut('/system/user/profile/update-password', form.value).then(() => {
        ElMessage.success({
          message: '更新成功',
          appendTo: '#password-form',
          duration: 1000,
          onClose: () => emits('logout', false)
        });
      }).catch(e => {
        ElMessage.error({
          message: '更新失败，' + e.message,
          appendTo: '#password-form'
        });
      });
    };
    const close = function () {
      emits('hide', false);
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        class: "password-dialog",
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => showDialog.value = $event),
        "close-on-click-modal": true,
        "show-close": true,
        style: {
          "max-width": "600px"
        },
        "before-close": close,
        title: "修改密码"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: close
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("关闭")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: save
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode(" 保存 ")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form, {
          model: form.value,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "原始密码"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value['oldPassword'],
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value['oldPassword'] = $event),
              type: "password"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "新密码"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value['newPassword'],
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value['newPassword'] = $event),
              type: "password"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "确认密码"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value['repass'],
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value['repass'] = $event),
              type: "password"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};